/*
 * SPIKE: the size option starts empty on product pages (see snippets/variant-main-picker.liquid).
 * This keeps it empty after other options change, and stops Add to cart / Buy it now
 * until the customer picks a size.
 */
(() => {
  if (window.spikeSizeRequired) return;
  window.spikeSizeRequired = true;

  const MESSAGE = 'من فضلك اختار المقاس';
  /** pickers where the customer has picked a size themselves */
  const chosen = new WeakSet();

  const sizeInputs = (picker) => picker.querySelectorAll('input[data-size-option]');
  const needsSize = (picker) => {
    const inputs = sizeInputs(picker);
    return inputs.length > 0 && !chosen.has(picker) && !Array.from(inputs).some((i) => i.checked);
  };

  const clearError = (picker) => {
    picker.querySelectorAll('.spike-size-error').forEach((el) => el.remove());
    picker.querySelectorAll('fieldset[data-size-option]').forEach((f) => f.classList.remove('spike-size-missing'));
  };

  const showError = (picker) => {
    const fieldset = picker.querySelector('fieldset[data-size-option]');
    if (!fieldset) return;
    clearError(picker);
    fieldset.classList.add('spike-size-missing');
    const msg = document.createElement('p');
    msg.className = 'spike-size-error';
    msg.setAttribute('role', 'alert');
    msg.textContent = MESSAGE;
    fieldset.after(msg);
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  /** After the theme re-renders the picker (e.g. a colour change), keep the size empty if none was picked. */
  const keepEmpty = (picker) => {
    if (chosen.has(picker)) return;
    sizeInputs(picker).forEach((input) => {
      input.checked = false;
      input.dataset.currentChecked = 'false';
    });
    if (picker.dataset.templateProductMatch === 'true') {
      const url = new URL(window.location.href);
      if (url.searchParams.has('variant')) {
        url.searchParams.delete('variant');
        setTimeout(() => history.replaceState({}, '', url.toString()), 0);
      }
    }
  };

  const init = (picker) => {
    if (Array.from(sizeInputs(picker)).some((i) => i.checked)) chosen.add(picker);
  };

  /** The variant picker that belongs to a buy button or form. */
  const pickerFor = (el) => {
    const formComponent = el.closest('product-form-component');
    const productId = formComponent?.dataset.productId;
    const scope = el.closest('quick-add-dialog, dialog, .shopify-section') || document;
    if (productId) {
      const picker = scope.querySelector(`variant-picker[data-product-id="${productId}"]`);
      if (picker) return picker;
    }
    return scope.querySelector('variant-picker');
  };

  const guard = (event, el) => {
    const picker = pickerFor(el);
    if (!picker || !needsSize(picker)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(picker);
  };

  document.querySelectorAll('variant-picker').forEach(init);

  customElements.whenDefined('variant-picker').then(() => {
    const VariantPicker = customElements.get('variant-picker');
    const update = VariantPicker.prototype.updateVariantPicker;
    VariantPicker.prototype.updateVariantPicker = function (html) {
      const result = update.call(this, html);
      keepEmpty(this);
      return result;
    };
    document.querySelectorAll('variant-picker').forEach(init);
  });

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.dataset.sizeOption) return;
      const picker = input.closest('variant-picker');
      if (!picker) return;
      chosen.add(picker);
      clearError(picker);
    },
    true
  );

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.closest('product-form-component')) guard(event, form);
    },
    true
  );

  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest(
        'shopify-accelerated-checkout, .shopify-payment-button, product-form-component [type="submit"], add-to-cart-component button'
      );
      if (button) guard(event, button);
    },
    true
  );

  const style = document.createElement('style');
  style.textContent = `
    fieldset.spike-size-missing { outline: 1px solid #d93025; outline-offset: 6px; border-radius: 4px; }
    .spike-size-error { color: #d93025; font-size: 0.9em; margin: 0.5em 0 0; }
  `;
  document.head.append(style);
})();
